export default "__VITE_ASSET__DlhkOZL7__"